import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import About from "./components/About";
import Services from "./components/Services";
import Clinics from "./components/Clinics";
import Testimonials from "./components/Testimonials";
import Awards from "./components/Awards";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      style={{ fontFamily: "'Segoe UI', sans-serif" }}
      className="bg-slate-50 text-slate-800 overflow-x-hidden"
    >
      <Navbar scrolled={scrolled} />
      <Hero />
      <Stats />
      <About />
      <Services />
      <Clinics />
      <Testimonials />
      <Awards />
      <Contact />
      <Footer />

      <style>{`
        @media (max-width: 768px) {
          .hidden-mobile { display: none !important; }
        }
      `}</style>
    </div>
  );
}
